import { useState } from "react";

import {
  makePostApiCall,
  makePutApiCall,
} from "../../../../shared/makeApiCall";

import DeleteConfirmationForm from "../../../../components/forms/DeleteConfirmationForm";
import { SimpleNotificationType } from "../../../../components/SimpleNotification";
import ModelErrorComponent from "../../../../components/modals/ModelErrorComponent";

export function UserDetailsViewModel(logout, userId) {
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState({ type: {} });

  const [showSimpleNotification, setShowSimpleNotification] = useState({
    show: false,
    message: null,
    title: null,
    type: SimpleNotificationType.Success,
  });

  const showErrorModal = (title, subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title={title}
        />
      ),
      open: true,
    });
  };

  const getUser = async function (search, page) {
    setLoading(true);
    const payload = {
      page: page,
      search: search,
    };
    let callResult = await makePostApiCall(`users/${userId}`, payload);
    if (callResult.success) {
      setUser(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
    setLoading(false);
  };

  const createUser = async function (values) {
    let callResult = await makePostApiCall(`createUser`, values);

    if (callResult.success) {
      setShowSimpleNotification({
        show: true,
        title: "User created",
        type: SimpleNotificationType.Success,
      });
      window.location = "/users/" + callResult.data.id;
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const updateUser = async function (values) {
    let callResult = await makePutApiCall(`users/${userId}`, values);

    if (callResult.success) {
      setShowSimpleNotification({
        show: true,
        title: callResult.data.message,
        type: SimpleNotificationType.Success,
      });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  // const deleteCustomer = async function (id, index) {
  //   setLoading(true);

  //   let callResult = await makePostApiCall(`deleteCustomer/${id}`, {});
  //   setLoading(false);
  //   if (callResult.success) {
  //     setEmptyModelOpen({
  //       open: false,
  //       childComponent: null,
  //     });
  //     setShowSimpleNotification({
  //       show: true,
  //       title: callResult.data.message,
  //       type: SimpleNotificationType.Success,
  //     });
  //   } else {
  //     if (callResult.errorStatus === 401) {
  //       logout();
  //     }
  //   }
  // };

  // const askDeleteCustomer = function (customer, index) {
  //   setEmptyModelOpen({
  //     childComponent: (
  //       <DeleteConfirmationForm
  //         buttonMessage="Delete"
  //         confirmAction={() => deleteCustomer(customer.id, index)}
  //         message={`Are you sure you want to delete ${customer.name}?`}
  //         setOpen={setEmptyModelOpen}
  //       />
  //     ),
  //     open: true,
  //   });
  // };

  return {
    createUser,
    updateUser,
    getUser,
    showSimpleNotification,
    setShowSimpleNotification,
    user,
    loading,
    emptyModal,
  };
}
